// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SidebarComments-cls1__c753a6640faa2bf90fc0{/*!*/}.SidebarComments-cls2___680cd8256083c8bc1fa{border-bottom:1px solid #dddde2;border-bottom:1px solid var(--stroke-light, #dddde2);margin-bottom:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SidebarComments-cls1__c753a6640faa2bf90fc0",
	"cls2": "SidebarComments-cls2___680cd8256083c8bc1fa SidebarComments-cls1__c753a6640faa2bf90fc0"
};
export default ___CSS_LOADER_EXPORT___;
